import { render, staticRenderFns } from "./CalendarOfWork.vue?vue&type=template&id=a5886e9e&scoped=true&"
import script from "./CalendarOfWork.vue?vue&type=script&lang=js&"
export * from "./CalendarOfWork.vue?vue&type=script&lang=js&"
import style0 from "./CalendarOfWork.vue?vue&type=style&index=0&id=a5886e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5886e9e",
  null
  
)

export default component.exports